/**
 * @generated SignedSource<<36906fae269f267c44c365aaca246518>>
 * @relayHash 389af168eb0543cdf47ad388e5fca725
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c904a3e08be2badecee1d367fc8c81c57b3bad9c725d082c699aa71f3a2477bb

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { VirtualAgentPerformanceQuery } from './VirtualAgentPerformanceQuery.graphql';

import checkForAiEnabledFF_provider from '@atlassian/jira-relay-provider/src/jsm-va-is-require-ai-enabled.relayprovider';
import showNextStepsEnabled_provider from '@atlassian/jira-relay-provider/src/jsm-va-next-steps.relayprovider';
import vaStatusHeaderEnabled_provider from '@atlassian/jira-relay-provider/src/jsm-va-status-header.relayprovider';

const node: PreloadableConcreteRequest<VirtualAgentPerformanceQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "c904a3e08be2badecee1d367fc8c81c57b3bad9c725d082c699aa71f3a2477bb",
    "metadata": {},
    "name": "VirtualAgentPerformanceQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvastatusheaderrelayprovider": vaStatusHeaderEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvanextstepsrelayprovider": showNextStepsEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": checkForAiEnabledFF_provider
    }
  }
};

export default node;
